import { Tag } from './Tag';

class LinkTag extends Tag {
  constructor(attributes) {
    super();
    this.type = 'link';
    this.prefix = 'thd-helmet__link--';
    this.attributes = attributes;
    if (!attributes.id) {
      console.warn('should should specify and ID to link tags');
    } else {
      this.attributes.id = `${this.prefix}${this.attributes.id}`;
    }
  }

  updateDom() {
    let el = document.getElementById(this.attributes.id);
    if (!el) {
      el = document.createElement('link');
      document.head.appendChild(el);
    }
    Object.keys(this.attributes).forEach((attr) => {
      el.setAttribute(attr, this.attributes[attr]);
    });
  }

  removeFromDom() {
    if (this.attributes.id) {
      const el = document.getElementById(this.attributes.id);
      if (el && el.remove) {
        el.remove();
      }
    }
  }

  toString() {
    const values = Object.keys(this.attributes).map((key) => {
      return `${key}="${this.attributes[key]}"`;
    }).join(' ');
    return `<link data-th="server" ${values}>`;
  }
}

export { LinkTag };
